import { createStyles, makeStyles } from '@material-ui/core';
import { white } from '@signaturit/react-components-library';

const dividerColor = 'rgba(255, 255, 255, 0.16)';
const hoverColor = '#f5f5ff';
const borderColor = '#0304a0';
const fontColor = '#020250';

export const useSideNavigationMenuItemStyles = makeStyles(() =>
    createStyles({
        container: {
            border: `1px solid ${borderColor}`,
            borderTop: 0,
            borderRadius: 10,
            borderBottomLeftRadius: 4,
            borderBottomRightRadius: 4,
            marginBottom: 4,
        },
        link: {
            width: '100%',
            color: `${white} !important`,
            textDecoration: 'none',

            '&:hover': {
                textDecoration: 'underline',
            },
        },
        listIcon: {
            paddingRight: 8,
            '&$listIconCollapsed': {
                paddingRight: 0,
                margin: '0 auto',
            },
        },
        listIconSelected: {
            paddingRight: 8,
            color: white,
            '&$listIconSelectedCollapsed': {
                paddingRight: 0,
                margin: '0 auto',
            },
        },
        listIconCollapsed: {},
        listIconSelectedCollapsed: {},
        menuListItem: {
            maxWidth: 224,
            padding: '8px',
            borderRadius: '4px !important',
            border: '1px solid transparent',
            height: 40,
            margin: '0 auto !important',
            marginBottom: '4px !important',

            '&$menuListItemCollapsed': {
                paddingLeft: 0,
                paddingRight: 0,
            },

            '&$menuListItemSelectedCollapsed': {
                backgroundColor: 'transparent !important',
            },

            '&:hover': {
                backgroundColor: `${hoverColor} !important`,
                border: `solid 1px ${borderColor}`
            },
        },
        menuListItemCollapsed: {},
        menuListItemMultiSelected: {
            color: `${fontColor}`,
            outline: `1px solid ${borderColor}`,
            borderTopLeftRadius: '4px !important',
            borderTopRightRadius: '4px !important',
            marginBottom: -1,
            border: '0px solid transparent',
            zIndex: 1,
            '&:hover': {
                border: '0px solid transparent',
            }
        },
        menuListItemSelected: {
            color: `${fontColor}`,
            border: `solid 1px ${borderColor}`,
        },
        menuListItemSelectedCollapsed: {},
        menuListItemTag: {
            display: 'inline-block',
            marginLeft: 6,
        },
        menuListItemContent: {
            color: `${fontColor}`,
        },
        menuListItemContentSelected: {
            fontWeight: 500,
        },
        divider: {
            backgroundColor: dividerColor,
            width: 192,
        },
        caret: {
            color: `${fontColor}`,
        },
        caretSelected: {
        },
    })
);
